import { Anchor, Text } from '@mantine/core';

import classes from './Footer.module.css';

const PrivacyPolicy = () => (
  <Anchor
    classNames={classes}
    href="https://policies.google.com/privacy"
    target="_blank"
  >
    Privacy Policy
  </Anchor>
);

const TermsOfService = () => (
  <Anchor
    classNames={classes}
    href="https://policies.google.com/terms"
    target="_blank"
  >
    Terms of Service
  </Anchor>
);

export const Footer = () => {
  return (
    <Text classNames={classes}>
      This site is protected by reCAPTCHA and the Google <PrivacyPolicy /> and{' '}
      <TermsOfService /> apply.
    </Text>
  );
};
